var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWsgContactCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 77,
    viewBox: "0 0 97 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M59.1036 42.2512H82.2726V34.5512H59.1036V42.2512ZM59.1036 27.4441H82.2726V19.7441H59.1036V27.4441ZM14.7274 57.2559H52.0341V55.4207C52.0341 51.9985 50.3502 49.3099 46.9825 47.355C43.6155 45.4001 39.0816 44.4226 33.3808 44.4226C27.6799 44.4226 23.1456 45.4001 19.7778 47.355C16.4109 49.3099 14.7274 51.9985 14.7274 55.4207V57.2559ZM33.3808 37.7108C35.8611 37.7108 37.97 36.8368 39.7075 35.0889C41.4458 33.3419 42.315 31.2214 42.315 28.7274C42.315 26.2326 41.4458 24.1117 39.7075 22.3647C37.97 20.6176 35.8611 19.7441 33.3808 19.7441C30.9005 19.7441 28.7911 20.6176 27.0528 22.3647C25.3153 24.1117 24.4466 26.2326 24.4466 28.7274C24.4466 31.2214 25.3153 33.3419 27.0528 35.0889C28.7911 36.8368 30.9005 37.7108 33.3808 37.7108ZM0 77V0H97V77H0ZM7.65789 69.3H89.3421V7.7H7.65789V69.3Z",
    fill: "#474F56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsgContactCard);
export default __webpack_public_path__ + "static/media/wsg-contact-card.7f08bc673f3869590fbd4d6b1ddee7bf.svg";
export { ForwardRef as ReactComponent };